import { Component, OnInit, Input } from "@angular/core";
import { CommonService } from "../service/common.service";
import { UsersService } from "../service/users.service";
import { YoyakuMasterService } from "../service/ymaster.service";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";

@Component({
  selector: "yconditions-group-m-app",
  templateUrl: "./yconditions-group-m.component.html",
  styleUrls: ["yconditions-group-m.component.css"],
})
export class YConditionsGroupMComponent implements OnInit {
  title: string = "予約条件（中）";
  isLoaded: boolean = false;
  selected: boolean = false;
  all_datalist: any = [];
  datalist: any = [];
  all_count: number;
  conditionlist: any = [];
  tempSelectedRow: any;
  display_per_page: number = 2; /* 最大表示件数 */
  content_list_info: any = {
    name_name: "条件の名称を入力してください。",
    data: {},
    conditionsList: [],
    conjunctionList: [
      { id: 0, name: "且つ", conjunction: "AND" },
      { id: 1, name: "または", conjunction: "OR" },
    ],
  };
  selected_s_condition_id: string = null;
  selectedContentName: string = "";
  selectedMasterIds: string = "";
  inputMode: number = null;
  numValue: string = null;
  error: boolean = false;
  operatorlist: any = [
    { id: 0, name: "等しい", operator: "=", enabled: true },
    { id: 1, name: "以上", operator: "<=", enabled: true },
    { id: 2, name: "以下", operator: ">=", enabled: true },
    { id: 3, name: "含む", operator: "IN", enabled: true },
  ];

  constructor(
    private commonService: CommonService,
    private ymasterService: YoyakuMasterService,
    private modalService: NgbModal,
    private router: Router,
    public usersService: UsersService,
    private route: ActivatedRoute,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.getList();
  }
  clearData(): void {
    this.isLoaded = false;
    this.selected = false;
    this.datalist = [];
  }
  getList(): void {
    this.ymasterService.getConditionsM().subscribe(
      (res: Response) => {
        if (res["fuel_status"] == "OK") {
          this.conditionlist = res["fuel_results"]["fixed_condition"];
          this.datalist = res["fuel_results"]["condition_m"];
          this.all_count = res["fuel_results"]["all_count_m"];
          this.content_list_info.conditionsList =
            res["fuel_results"]["condition_s"];
          // this.changePage(1);
          this.isLoaded = true;
        } else if (res["fuel_status"] == "NG") {
          this.commonService.modalOpens(
            res["fuel_message"],
            (modalresult) => {}
          );
        } else {
          this.commonService.modalOpens(11003, (modalresult) => {});
        }
      },
      (error) => {
        this.commonService.modalOpens(error, (modalresult) => {});
      }
    );
  }
  save(): void {
    this.commonService.modalOpens(
      50001,
      //保存してもよろしいですか？
      (modalresult) => {
        if (modalresult == "OK") {
          this.ymasterService
            .saveConditionsM(this.content_list_info.data)
            .subscribe(
              (res: Response) => {
                if (res["fuel_status"] == "OK") {
                  this.commonService.modalOpens(10001, (modalresult) => {
                    this.editSelectRowData(undefined);
                    this.selected = false;
                    this.getList();
                  });
                } else if (res["fuel_status"] == "NG") {
                  this.commonService.modalOpens(
                    res["fuel_message"],
                    (modalresult) => {}
                  );
                } else {
                  this.commonService.modalOpens(11003, (modalresult) => {});
                }
              },
              (error) => {
                this.commonService.modalOpens(error, (modalresult) => {});
              }
            );
        } else {
          //
        }
      }
    );
  }
  delete(): void {
    this.commonService.modalOpens(
      50002,
      //削除してもよろしいですか？
      (modalresult) => {
        if (modalresult == "OK") {
          this.ymasterService
            .deleteConditionsM(this.content_list_info.data)
            .subscribe(
              (res: Response) => {
                if (res["fuel_status"] == "OK") {
                  this.commonService.modalOpens(10002, (modalresult) => {
                    this.editSelectRowData(undefined);
                    this.selected = false;
                    this.getList();
                  });
                } else if (res["fuel_status"] == "NG") {
                  this.commonService.modalOpens(
                    res["fuel_message"],
                    (modalresult) => {}
                  );
                } else {
                  this.commonService.modalOpens(11003, (modalresult) => {});
                }
              },
              (error) => {
                this.commonService.modalOpens(error, (modalresult) => {});
              }
            );
        } else {
        }
      }
    );
  }
  changePage(e) {
    var start = (e - 1) * this.display_per_page;
    this.datalist = this.all_datalist.slice(
      start,
      start + this.display_per_page
    );
  }
  edit(row: any): void {
    if (this.selected) {
      this.commonService.modalOpens(
        50005,
        //編集中の内容を破棄してもよろしいですか？
        (modalresult) => {
          if (modalresult == "OK") {
            this.editSelectRowData(row);
            //画面上部へ移動
            window.scrollTo(0, 0);
          } else {
            return;
          }
        }
      );
    } else {
      this.editSelectRowData(row);
      //画面上部へ移動
      window.scrollTo(0, 0);
    }
  }
  editSelectRowData(row: any): void {
    if (row == undefined) {
      this.selected = true;
      this.content_list_info.data = {
        t_conditions_m_id: null,
        t_conditions_m_name: null,
        sort: null,
        update_datetime: null,
        content: [
          {
            t_conditions_s_id: null,
            s_yoyaku_conditions_id: null,
            conditions_s_name: null,
            conjunction: null,
          },
        ],
      };
    } else {
      this.selected = true;
      this.content_list_info.data = JSON.parse(JSON.stringify(row));
      this.tempSelectedRow = JSON.parse(JSON.stringify(row));
    }
  }
  checkList(): boolean {
    if (
      this.content_list_info.data.t_conditions_m_name == null ||
      this.content_list_info.data.t_conditions_m_name == ""
    ) {
      return true;
    } else {
      var tmp = [];
      tmp = this.content_list_info.data.content.filter(
        (item) => item.t_conditions_s_id == null
      );
      if (tmp.length > 0) {
        return true;
      } else {
        if (this.content_list_info.dupcheckLists) {
          return true;
        } else {
          var err = [];
          for (let i = 0; this.content_list_info.data.content.length > i; i++) {
            if (i == this.content_list_info.data.content.length - 1) {
              //
            } else {
              err.push(this.content_list_info.data.content[i].conjunction);
            }
          }
          err = err.filter((item) => item === null);
          if (err.length > 0) {
            return true;
          } else {
            return false;
          }
        }
      }
    }
  }
  cancel(): void {
    this.commonService.modalOpens(
      50005,
      //編集中の内容を破棄してもよろしいですか？
      (modalresult) => {
        if (modalresult == "OK") {
          this.selected = false;
        } else {
        }
      }
    );
  }
  upRow(row: number, data: any): void {
    let tempdatalist;
    tempdatalist = this.datalist;
    if (row == 0) {
      //最初
    } else {
      //自分のレコード　myRecord
      let myRecord = tempdatalist[row];
      //１つ前のレコード beforeRecord
      let beforeRecord = tempdatalist[row - 1];
      // 旧sortを退避
      myRecord["chk_sort"] = myRecord["sort"];
      beforeRecord["chk_sort"] = beforeRecord["sort"];
      //sortnoを交換する
      let tmpsort = myRecord["sort"];
      myRecord["sort"] = beforeRecord["sort"];
      beforeRecord["sort"] = tmpsort;
      //２レコードをUPDATEする　myRecord,beforeRecord
      this.ymasterService
        .changeOrderConditionM([myRecord, beforeRecord])
        .subscribe(
          (res: Response) => {
            if (res["fuel_status"] == "OK") {
              tempdatalist.splice(
                row - 1,
                2,
                tempdatalist[row],
                tempdatalist[row - 1]
              );
            } else if (res["fuel_status"] == "NG") {
              this.commonService.modalOpens(
                res["fuel_message"],
                (modalresult) => {}
              );
            } else {
              this.commonService.modalOpens(11003, (modalresult) => {});
            }
          },
          (error) => {
            this.commonService.modalOpens(error, (modalresult) => {});
          }
        );
    }
  }
  downRow(row: number, data: any): void {
    let tempdatalist;
    tempdatalist = this.datalist;
    if (row == tempdatalist.length - 1) {
      //最終
    } else {
      //１つ後ろのレコード afterRecord
      let afterRecord = tempdatalist[row + 1];
      //自分のレコード　myRecord
      let myRecord = tempdatalist[row];
      // 旧sortを退避
      myRecord["chk_sort"] = myRecord["sort"];
      afterRecord["chk_sort"] = afterRecord["sort"];
      //sortnoを交換する
      let tmpsort = myRecord["sort"];
      myRecord["sort"] = afterRecord["sort"];
      afterRecord["sort"] = tmpsort;
      //２レコードをUPDATEする　myRecord,afterRecord
      this.ymasterService
        .changeOrderConditionM([myRecord, afterRecord])
        .subscribe(
          (res: Response) => {
            if (res["fuel_status"] == "OK") {
              tempdatalist.splice(
                row,
                2,
                tempdatalist[row + 1],
                tempdatalist[row]
              );
            } else if (res["fuel_status"] == "NG") {
              this.commonService.modalOpens(
                res["fuel_message"],
                (modalresult) => {}
              );
            } else {
              this.commonService.modalOpens(11003, (modalresult) => {});
            }
          },
          (error) => {
            this.commonService.modalOpens(error, (modalresult) => {});
          }
        );
    }
  }
  goBack(): void {
    if (this.selected) {
      this.commonService.modalOpens(
        50005,
        //編集中の内容を破棄してもよろしいですか？
        (modalresult) => {
          if (modalresult == "OK") {
            this.location.back();
          }
        }
      );
    } else {
      this.location.back();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/a2126-yconditions-group-m/yconditions-group-m.component.ts